// extracted by mini-css-extract-plugin
export default {"addMediaButton":"addMediaButton__addMediaButton__ZlhPK","dark":"addMediaButton__dark__AMCxS"};